import moment from 'moment';

const normalizer = {};

normalizer.normalize = function(model, payload) {
  return new Promise(resolve => {
    if (payload instanceof Array) {
      this.normalizeCollection(model, payload);
    } else {
      this.normalizeResource(model, payload);
    }
    resolve();
  });
};

normalizer.normalizeResource = function(model, payload) {
  let normalized = {
    id: payload.uuid
  };

  Object.keys(model.fields())
    .filter(key => key.indexOf('Url') > -1)
    .forEach(key => {
      if (payload._links) {
        normalized[key] = payload._links[key.split('Url')[0]]
          ? payload._links[key.split('Url')[0]].href
          : '';
      }
    });

  Object.keys(model.fields())
    .filter(key => payload[this.toSnakeCase(key)] !== undefined)
    .forEach(key => {
      if (model.fields()[key].value == 'date') {
        normalized[key] = moment(payload[this.toSnakeCase(key)]);
      } else {
        normalized[key] = payload[this.toSnakeCase(key)];
      }
    });

  Object.keys(model.fields()).map(key => {
    if (
      model.fields()[key].value == 'date' &&
      payload[this.toSnakeCase(key)] === undefined
    ) {
      normalized[key] = null;
    }
  });

  Object.keys(model.fields())
    .filter(key => key.indexOf('_id') > -1)
    .forEach(key => {
      if (payload[key.replace('_id', '')]) {
        normalized[key] = payload[key.replace('_id', '')].uuid;

        delete normalized[key.replace('_id', '')];
      }
    });

  Object.keys(model.fields())
    .filter(key => key.indexOf('_collection') > -1)
    .forEach(key => {
      const collection = [];

      if (payload[key.replace('_collection', '')]) {
        payload[key.replace('_collection', '')].forEach(item => {
          collection.push(item.uuid);
        });
      }

      normalized[key] = collection;
    });

  if (model.deepGet) {
    model.deepGet.forEach(item => {
      normalized[`${item.parent}_${item.child}`] =
        payload[item.parent][item.child];
    });
  }

  if (model.autoNormalize) {
    model.autoNormalize.forEach(item => {
      if (item.type === 'single') {
        this.normalizeResource(item.model, payload[item.key]);
      } else {
        this.normalizeCollection(item.model, payload[item.key]);
      }
    });
  }

  model.insertOrUpdate({ data: normalized });
};

normalizer.normalizeCollection = function(model, payload) {
  payload.forEach(object => this.normalizeResource(model, object));
};

normalizer.toSnakeCase = function(key) {
  return key.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export default normalizer;
